import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=9398e2f0&scoped=true"
import script from "./sort.vue?vue&type=script&lang=ts"
export * from "./sort.vue?vue&type=script&lang=ts"
import style0 from "./sort.vue?vue&type=style&index=0&id=9398e2f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9398e2f0",
  null
  
)

export default component.exports